const MAILLIST_RIGHT_DATA = [
  {
    key: "Everyone",
    value: 0,
    text: "允许所有人"
  },
  {
    key: "ListAndAuthorized",
    value: 2,
    text: "允许列表中的用户和授权用户"
  },
  {
    key: "AuthorizedOnly",
    value: 3,
    text: "只允许授权用户"
  },
  {
    key: "SameDomain",
    value: 4,
    text: "允许域内所有用户"
  }
];
const MAILLIST_RIGHT = {};
const MAILLIST_RIGHT_TEXT = {};
for (let item of MAILLIST_RIGHT_DATA) {
  MAILLIST_RIGHT[item.key] = item.value;
  MAILLIST_RIGHT_TEXT[item.value] = item.text;
}
export { MAILLIST_RIGHT, MAILLIST_RIGHT_TEXT };
